export default function() {
    window.uniqueTrackNames = [];
    
    document.body.addEventListener('2022-accenture-progress-25', function(){
        if ($('.hub-hero').length == 0) {
            UniqueScrollTrack('2022-accenture-progress-25');
        }
    });

    document.body.addEventListener('2022-accenture-progress-50', function(){
        if ($('.hub-hero').length == 0) {
            UniqueScrollTrack('2022-accenture-progress-50');
        }
    });

    document.body.addEventListener('2022-accenture-progress-75', function(){
        if ($('.hub-hero').length == 0) {
            UniqueScrollTrack('2022-accenture-progress-75');
        }
    });

    document.body.addEventListener('2022-accenture-progress-100', function(){
        if ($('.hub-hero').length == 0) {
            UniqueScrollTrack('2022-accenture-progress-100');
        }
    });

    
    document.body.addEventListener('2022-accenture-animation1', function(){
        UniqueScrollTrack('2022-accenture-animation1');
    });

    document.body.addEventListener('2022-accenture-animation2', function(){
        UniqueScrollTrack('2022-accenture-animation2');
    });

    document.body.addEventListener('2022-accenture-animation3', function(){
        UniqueScrollTrack('2022-accenture-animation3');
    });

    
    $(document).on('click', '#hero .powered, .menu-holder .logo a', function() {
        UniqueScrollTrack('2022-accenture-logo-top');
    });
    $(document).on('click', '.hub-hero .hero_logo a', function() {
        UniqueScrollTrack('2022-accenture-hub-logo-top');
    });

    $(document).on('click', '.hero_menu-btn.-open', function() {
        UniqueScrollTrack('2022-accenture-menu');
    });

    $(document).on('click', '.menu_nav li:nth-child(1) a', function() {
        UniqueScrollTrack('2022-accenture-menu-1');
    });

    $(document).on('click', '.menu_nav li:nth-child(2) a', function() {
        UniqueScrollTrack('2022-accenture-menu-2');
    });

    $(document).on('click', '.menu_nav .action a', function() {
        UniqueScrollTrack('2022-accenture-menu-hub');
    });

    $(document).on('click', 'a[data-analytics="2022-accenture-learn-1"]', function() {
        UniqueScrollTrack('2022-accenture-learn-1');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-learn-2"]', function() {
        UniqueScrollTrack('2022-accenture-learn-2');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-learn-3"]', function() {
        UniqueScrollTrack('2022-accenture-learn-3');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-cta-1"]', function() {
        UniqueScrollTrack('2022-accenture-cta-1');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-cta-2"]', function() {
        UniqueScrollTrack('2022-accenture-cta-2');
    });
    $(document).on('click', '[data-analytics="2022-accenture-hub-filter-A"]', function() {
        UniqueScrollTrack('2022-accenture-hub-filter-A');
    });
    $(document).on('click', '[data-analytics="2022-accenture-hub-filter-B"]', function() {
        UniqueScrollTrack('2022-accenture-hub-filter-B');
    });
    $(document).on('click', '[data-analytics="2022-accenture-hub-filter-C"]', function() {
        UniqueScrollTrack('2022-accenture-hub-filter-C');
    });
    $(document).on('click', '[data-analytics="2022-accenture-hub-filter-D"]', function() {
        UniqueScrollTrack('2022-accenture-hub-filter-D');
    });
    $(document).on('click', '[data-analytics="2022-accenture-hub-filter-E"]', function() {
        UniqueScrollTrack('2022-accenture-hub-filter-E');
    });

    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-1"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-1');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-2"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-2');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-3"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-3');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-4"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-4');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-5"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-5');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-6"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-6');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-7"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-7');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-8"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-8');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-9"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-9');
    });
    $(document).on('click', 'a[data-analytics="2022-accenture-hub-article-10"]', function() {
        UniqueScrollTrack('2022-accenture-hub-article-10');
    });

    $(document).on('click', 'a[data-analytics="2022-accenture-hub-cta"]', function() {
        UniqueScrollTrack('2022-accenture-hub-cta');
    });

    

    function UniqueScrollTrack(text) {
        if (uniqueTrackNames.indexOf(text) == -1) {
            uniqueTrackNames.push(text);
            scrollTrack(text, text);
        }
    }
    
    function scrollTrack(text, customlink) {
        if (typeof(s) != 'undefined' && s) {
            s.events = 'event76';
            s.prop69 = text;
            s.eVar69 = 'D=c69';
            s.pageURL = window.location.href;
            s.tl(true, 'o', customlink);
            s.prop69 = s.eVar69 = s.events = '';
        }
    }

    var playVideoTracking = true;
    var endedVideoTracking = true;
    var halfPlayedVideoTrackingFlag = true;
    $('#overlay-video').on('timeupdate', function(data) {

        var currentTime = this.currentTime;
        var percent = (currentTime/this.duration);
        if (playVideoTracking) {
            playedVideoTracking('2022-accenture-video-start');
            playVideoTracking = false;
        }
        if (percent >= 0.5 && halfPlayedVideoTrackingFlag) {
            halfPlayedVideoTracking('2022-accenture-video-50%', true);
            halfPlayedVideoTrackingFlag = false;
        }

        if (percent > 0.97 && endedVideoTracking) {
            endVideoTracking('2022-accenture-video-complete', true);
            endedVideoTracking = false;
        }

    });

    function playedVideoTracking(title) {

        if (typeof(s) != 'undefined' && s) {
        s.events = 'event32';
        s.prop29 = title;
        s.eVar41 = 'D=c29';
        s.tl(true, 'o', 'cnnadfeaturevideo:play');
        s.events = s.prop29 = s.eVar41 = '';
        }
    }
    function halfPlayedVideoTracking(title, additionalEvent) {

        if (typeof(s) != 'undefined' && s) {
            s.events = 'event2';
            if (additionalEvent) {
                s.events += ',event36';
            }
            s.prop29 = title;
            s.eVar41 = 'D=c29';
            s.tl(true, 'o', 'cnnadfeaturevideo:milestone');
            s.events = s.prop29 = s.eVar41 = '';
        }
    }
    function endVideoTracking(title, additionalEvent) {

        if (typeof(s) != 'undefined' && s) {
            s.events = 'event33';
            if (additionalEvent) {
                s.events += ',event36';
            }
            s.prop29 = title;
            s.eVar41 = 'D=c29';
            s.tl(true, 'o', 'cnnadfeaturevideo:complete');
            s.events = s.prop29 = s.eVar41 = s.products = '';
        }
    }

}